import SubMenu from 'common/navigation/components/sub-menu';
import MainMenu from 'common/navigation/containers/main-menu-container';
import Wrapper from 'common/navigation/wrapper';
import React from 'react';
import { Navigate, Outlet, Route, Routes, useParams } from 'react-router-dom';
import { ticketObjectRoutes } from '../common/navigation/routes/cops-routes';
import TicketWorklistContainer from '../tickets/containers/list/ticket-worklist-container';
import NotificationCallDetailsContainer from './containers/notification_call-container';

const CallRoutes = () => {
  const params = useParams();
  // As notifications and calls use the same component, we will determine what we want to show
  // via the match params.
  const id = params.callId;
  const renderMenu = (actionButtons, extraLinks = []) =>
    <MainMenu type={'call'} id={id} actionButtons={actionButtons}>
      <SubMenu
        id={id}
        hasInfo={false}
        baseType='call'
        hasTickets={true}
        dashboardTranslation='nav.subNav.DETAILS'
        base={`call/${id}`}
        extraLinks={[
          ...extraLinks,
        ]}
      />
    </MainMenu>;

  const ticketRoutes = ticketObjectRoutes();
  return (
    <Wrapper title={'Call'}>
      <Routes>
        <Route
          path={'dashboard/*'}
          element={<NotificationCallDetailsContainer
            renderMenu={renderMenu} id={id} isNotification={false}
          />}
        />
        {ticketRoutes?.map((r, i) => <Route
          path={`${r}/*`}
          key={i}
          element={
            <TicketWorklistContainer
              renderMenu={renderMenu}
              isNotificationCall={true}
              baseType='call'
            />
          }
        />)}
        <Route
          path='/*'
          element={<Navigate to='dashboard' replace />}
        />
      </Routes>
      <Outlet />
    </Wrapper>
  );
};

CallRoutes.propTypes = {};

export default CallRoutes;
